export const CHECK_LISTS_PATHS = {
  checkLists: 'check-lists',
  composing: 'composing',
  reporting: 'reporting',
  reporting_grrs: 'reporting-grrs',
};
